<template>
  <div
    class="flex align-center ag-row-with-bg full-w-cell-trans"
    style="flex-wrap: wrap"
  >
    <div v-if="params.data.label">{{ params.data.label }}</div>
    <div class="flex cell-trans__content">
      <template v-if="params.data.billNumber">
        <div>Số hoá đơn: {{ params.data.billNumber }}</div>
        <div>Recode: {{ params.data.bookingCode }}</div>
        <div>Ngày hóa đơn: {{ params.data.billDate }}</div>
        <div>Lễ tân: {{ params.data.createdBy }}</div>
        <div>Số phòng: {{ params.data.roomNum }}</div>
        <div>
          Tổng tiền giảm giá:
          {{ $displayCurrency(params.data.totalDiscount) }}
        </div>
        <div>Thành tiền: {{ $displayCurrency(params.data.totalBill) }}</div>
      </template>
      <template
        v-else-if="
          params.data.totalBill !== null || params.data.totalBill !== undefined
        "
      >
        <div v-if="params.data.includeTaxFee">Bao gồm thuế, phí</div>
        <div>
          Tổng tiền giảm giá: {{ $displayCurrency(params.data.totalDiscount) }}
        </div>
        <div>
          Tổng tiền hóa đơn {{ params.data.billNum }}:
          {{ $displayCurrency(params.data.totalBill) }} (Phí dịch vụ:
          <span style="display: inline-block; margin-right: 4px"
            >{{ $displayCurrency(params.data.serviceFee) }}
          </span>
          Thuế GTGT:
          <span style="display: inline-block"
            >{{ $displayCurrency(params.data.taxFee) }} </span
          >)
        </div>
      </template>
      <template
        v-else-if="
          params.data.totalServiceBill !== null &&
          params.data.totalServiceBill !== undefined
        "
      >
        <div>
          Tổng {{ $displayCurrency(params.data.service) }}:
          {{ $displayCurrency(params.data.totalServiceBill) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.ag-row-with-bg {
  background-color: $ag-selected-row-background-color;
}

.full-w-cell-trans {
  width: 100%;
  height: 100%;
  padding-left: 10px;

  .cell-trans__content {
    gap: 40px;
    width: 100%;
    min-width: 700px;
    font-weight: 500;
    padding-right: 10px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 6px !important;
    }
  }
}
</style>
